export const clamp = (x, lower, upper = Infinity) => {
  if (x < lower) return lower;
  if (x > upper) return upper;
  return x;
};
